import { alpha } from "@mui/material/styles";
import { drawerClasses } from "@mui/material/Drawer";

// ----------------------------------------------------------------------

export default function Drawer(theme) {
  const isLight = theme.palette.mode === "light";

  return {
    MuiDrawer: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.variant === "temporary" && {
            [`& .${drawerClasses.paper}`]: {
              // Superficie principal y OPACA. No usa el helper `paper()` a
              // propósito: ese aplica el color al 90% sobre un backdrop-filter,
              // así que el drawer nunca quedaba en el color exacto.
              backgroundColor: theme.palette.background.default,
              backgroundImage: "none",
              ...(ownerState.anchor === "left" && {
                boxShadow: `40px 40px 80px -8px ${alpha(
                  isLight ? theme.palette.grey[500] : theme.palette.common.black,
                  0.24
                )}`,
              }),
              ...(ownerState.anchor === "right" && {
                boxShadow: `-40px 40px 80px -8px ${alpha(
                  isLight ? theme.palette.grey[500] : theme.palette.common.black,
                  0.24
                )}`,
              }),
            },
          }),
        }),
      },
    },
  };
}
